var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-authorization-container',{attrs:{"page":_vm.page,"require-admin":""}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Create a new tier")]),_c('admin-tier-form',{attrs:{"data":_vm.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }